import React from 'react'
import './sectionWorks.css'

export const sectionWorks = () => {
  return (
    <div className='sectionWorks'>
      <span id='under_construction'>Under Construction :)</span>
    </div>
  )
}
export default sectionWorks;